import IMG1 from "./images/123-doc-p1.jpg";
import IMG2 from "./images/456-doc-p2.jpg";
import IMG3 from "./images/789-doc-p3.jpg";

const docData = [
  {
    number: "123-MEC-DWG-P1",
    title: "HMCL Mechanical Drawing Phase 1 ",
    rev: "A",
    img: IMG1,
  },
  {
    number: "456-MEC-GEN-P2",
    title: "HMCL Mechanical General Arrangement Phase 2",
    rev: "B",
    img: IMG2,
  },
  {
    number: "789-MEC-LAY-P3",
    title: "HMCL Mechanical Layout Phase 3",
    rev: "C",
    img: IMG3,
  },
  {
    number: "123-ELE-DWG-P1",
    title: "HMCL Electrical Drawing Phase 1 ",
    rev: "0",
    img: IMG1,
  },
  {
    number: "456-ELE-GEN-P2",
    title: "HMCL Electrical General Arrangement Phase 2",
    rev: "1",
    img: IMG2,
  },
  {
    number: "789-ELE-LAY-P3",
    title: "HMCL Electrical Layout Phase 3",
    rev: "2",
    img: IMG3,
  },
  {
    number: "123-PLM-DWG-P1",
    title: "HMCL Plumbing Drawing Phase 1 ",
    rev: "D",
    img: IMG1,
  },
  {
    number: "456-PLM-GEN-P2",
    title: "HMCL Plumbing General Arrangement Phase 2",
    rev: "4",
    img: IMG2,
  },
  {
    number: "789-PLM-LAY-P3",
    title: "HMCL Plumbing Layout Phase 3",
    rev: "F",
    img: IMG3,
  },
];

export default docData;
